module.exports = __webpack_public_path__ + "static/media/Maya.3af5e57b.png";